import axios from 'axios';
import type { AxiosInstance } from 'axios';
import { KitRegistrationInput } from './types';

export class KitRegistrationService {
  instance: AxiosInstance;

  constructor() {
    this.instance = axios.create({
      baseURL: import.meta.env.VITE_API_BASE_URL,
      headers: {
        'Content-Type': 'application/json',
      },
    });
  }

  async registerKit(input: KitRegistrationInput) {
    const response = await this.instance.post(
      '/kits/register-kit',
      {
        uniqueId: input.uniqueId,
        userId: input.userId,
      },
      {
        headers: {
          Authorization: `Bearer ${input.accessToken}`,
          'Content-Type': 'application/json',
        },
      }
    );
    return response.data;
  }
}
